// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"3b65e63b","453":"f63eee4e","777":"9d51ae7e"}[chunkId] + ".chunk.js";
};